import Swiper, { Navigation, Pagination } from "swiper";

export default function sliders() {

  (function simpleSlider() {
    // Install modules
    Swiper.use([Navigation, Pagination]);
    const swiper = new Swiper(".simple-slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      navigation: {
        nextEl: ".simple-slider-button-next",
        prevEl: ".simple-slider-button-prev",
      },
      pagination: {
        el: '.simple-slider-pagination',
        type: 'bullets',
        clickable: true
      }
      // breakpoints: {
      //   768: {
      //     slidesPerView: "auto",
      //     spaceBetween: 70,
      //   },
      // },
    });
  })();


}